import type {
  GroupingFeedbackSchemaType,
  GroupingFontSchemaType,
  GroupingSchemaType,
} from '@vedalib/editor/lib/brand'
import type { GroupingItem, GroupingGroup } from '@vedalib/editor/lib/elements'
import type { CSSProperties } from 'react'
import { createContext } from 'use-context-selector'

import { NOOP } from 'constants/commonConstans'
import type { ElementFeedbackCss, ElementFontCss, ElementStyleCss } from 'services/Branding/types'
import { PREVIEW_MODE } from 'services/Store/Project/constants'
import type { IBlockMode } from 'services/Store/Project/types'

import type { ValidationMap } from './components/DefaultView/PortalGroupingItem/PortalGroupingItem'

export interface IGroupingContextProps {
  destination: GroupingGroup[]
  hasGroupImage?: boolean
  hasAnswerImage?: boolean
  styles: ElementStyleCss<GroupingSchemaType>
  font?: ElementFontCss<GroupingFontSchemaType>
  feedback: ElementFeedbackCss<GroupingFeedbackSchemaType>
  mode: IBlockMode
  shuffledAnswers: GroupingItem[]
  testResult: { [key: string]: boolean }
  validationMap: ValidationMap
  elementId?: string
  retry: number
  setRetry: React.Dispatch<React.SetStateAction<number>>
  setDestination: React.Dispatch<React.SetStateAction<GroupingGroup[]>>
  setShuffledAnswers: React.Dispatch<React.SetStateAction<GroupingItem[]>>
  setTestResult: React.Dispatch<
    React.SetStateAction<{
      [key: string]: boolean
    }>
  >
  pdfStyles?: CSSProperties
  setValidationMap: React.Dispatch<React.SetStateAction<ValidationMap>>
}

const GroupingContext = createContext<IGroupingContextProps>({
  retry: 0,
  destination: [],
  hasGroupImage: false,
  hasAnswerImage: false,
  styles: {} as ElementStyleCss<GroupingSchemaType>,
  mode: PREVIEW_MODE,
  shuffledAnswers: [],
  testResult: {},
  feedback: {} as ElementFeedbackCss<GroupingFeedbackSchemaType>,
  validationMap: {},
  elementId: '',
  setDestination: NOOP,
  setRetry: NOOP,
  setShuffledAnswers: NOOP,
  setTestResult: NOOP,
  pdfStyles: {} as CSSProperties,
  setValidationMap: NOOP,
})

export default GroupingContext
